<template>
  <b-container style="opacity: 0; position: absolute; z-index: -1; top: -20%">
    <b-row id="print-me" class="justify-content-center pt-2" style="background-color: #f6f7fa">
      <b-col id="contentPrintA5" ref="contentPrintA5" cols="12" lg="10">
        <b-container class="h-100 bg-white" style="letter-spacing: 1px">
          <div class="pt-5 px-lg-3 px-2 pb-3">
            <div class="d-flex mb-4 align-items-center" style="gap: 8px">
              <b-img v-if="imageLogo" :src="imageLogo" alt="logo" style="width: 100px" />

              <div class="d-flex flex-column" style="gap: 2px">
                <h6 class="size18 text-black">Nota</h6>
                <h6 class="size18 fw-bold-500 text-black" v-if="result.branch">
                  {{ result.branch.name || "-" }}
                </h6>
                <h6 class="size18 fw-bold-500 text-black" v-if="result.branch">
                  {{ result.branch.address || "-" }}
                </h6>
                <h6>{{ (result.branch && result.branch.phone) || "-" }}</h6>
              </div>
            </div>
            <b-row class="mt-2">
              <b-col cols="12">
                <table>
                  <tbody>
                    <tr>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          No. Invoice
                        </h6>
                      </td>
                      <td class="pl-0 pr-3" style="width: 21rem">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          : {{ (result && result.invoice_number) || "-" }}
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          Tanggal
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          : {{ (result && result.date) || "-" }}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          No. PO SO
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          : {{ (result && result.po_so_number) || "-" }}
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          Pelanggan
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          :
                          {{ (result.customer && result.customer.name) || "-" }}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          No. Surat Jalan
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          : {{ deliveryNumbers.join(", ") || "-" }}
                        </h6>
                      </td>
                      <td class="pl-0 pr-3 pb-1 d-flex" v-if="isUsedCustomerPoint">
                        <h6 class="size18 mb-0 fw-bold-500 text-black">
                          Customer Point yang dimiliki
                        </h6>
                      </td>
                      <td class="pl-0 pr-3 pb-1" style="max-width: 300px" v-if="isUsedCustomerPoint">
                        <h6 class="size18 mb-0 fw-bold-500 text-black">
                          : {{ totalPoint || 0 | formatPoint }}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          Sales
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          : {{ (result.seller && result.seller.name) || "-" }}
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          Penerima
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          : {{ (result && result.receiver_name) || "-" }}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td class="pl-0 pr-3 d-flex">
                        <h6 class="size18 mb-0 fw-bold-500 text-black">
                          Kasir
                        </h6>
                      </td>
                      <td class="pl-0 pr-3" style="vertical-align: top">
                        <h6 class="size18 mb-0 fw-bold-500 text-black">
                          :
                          {{ (result.operator && result.operator.name) || "-" }}
                        </h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">Telp</h6>
                      </td>
                      <td class="pl-0 pr-3">
                        <h6 class="size18 fw-bold-500 text-black mb-0">
                          :
                          {{ (result && result.receiver_phone_number) || "-" }}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td class="pl-0 pr-3 pb-1 d-flex">
                        <h6 class="size18 mb-0 fw-bold-500 text-black">
                          Alamat Penerima
                        </h6>
                      </td>
                      <td class="pl-0 pr-3 pb-1" style="max-width: 300px">
                        <h6 class="size18 mb-0 fw-bold-500 text-black">
                          : {{ (result && result.receiver_address) || "-" }}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h6 v-if="formattedCreatedAt" class="size18 text-black mb-0 font-italic mt-2">
                  Dibuat : {{ formattedCreatedAt }}
                </h6>
              </b-col>
            </b-row>
            <b-row class="mt-1 ml-0">
              <b-col lg="12" class="pl-0">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr class="border-bottom" style="
                        border-bottom: 1px solid #000 !important;
                        border-top: 1px solid #000 !important;
                      ">
                      <th scope="col" class="text-left size18 align-middle" style="
                          border-bottom: 1px solid #000 !important;
                          border-top: 1px solid #000 !important;
                        ">
                        Item
                      </th>
                      <th scope="col" class="text-right size18 align-middle" style="
                          border-bottom: 1px solid #000 !important;
                          border-top: 1px solid #000 !important;
                        ">
                        Qty
                      </th>
                      <th scope="col" class="text-right size18 align-middle" style="
                          border-bottom: 1px solid #000 !important;
                          border-top: 1px solid #000 !important;
                        ">
                        Harga Satuan
                      </th>
                      <th scope="col" class="text-right size18 align-middle" style="
                          border-bottom: 1px solid #000 !important;
                          border-top: 1px solid #000 !important;
                        ">
                        Diskon Satuan
                      </th>
                      <th scope="col" class="text-right size18 align-middle" style="
                          border-bottom: 1px solid #000 !important;
                          border-top: 1px solid #000 !important;
                        ">
                        Harga
                      </th>
                      <th scope="col" class="text-right size18 align-middle" style="
                          border-bottom: 1px solid #000 !important;
                          border-top: 1px solid #000 !important;
                        ">
                        Jumlah
                      </th>
                    </tr>
                  </thead>
                 <tbody>
                    <template v-for="(entry, index) in groupedItems">
                      <!-- ========================= -->
                      <!-- NORMAL PRODUCT -->
                      <!-- ========================= -->
                      <tr v-if="entry.type === 'product'" :key="'product-' + index" style="page-break-inside: avoid;">
                        <td class="border-0 size18">
                          {{ entry.item.name }}
                        </td>

                        <td class="border-0 size18 text-right" style="padding-left: 1.5rem">
                          {{ entry.item.qty.toString().replace(".", ",") }}
                          {{ entry.item.unit }}
                        </td>

                        <td class="border-0 size18 text-right">
                          {{ entry.item.sub_price | formatInvoice }}
                        </td>

                        <td class="border-0 size18 text-right">
                          {{ entry.item.discount_per_item | formatInvoice }}
                        </td>

                        <td class="border-0 size18 text-right">
                          {{ entry.item.price | formatInvoice }}
                        </td>

                        <td class="border-0 size18 text-right">
                          {{ entry.item.total | formatInvoice }}
                        </td>
                      </tr>

                      <!-- ========================= -->
                      <!-- BUNDLE HEADER -->
                      <!-- ========================= -->
                      <template v-else>
                        <tr :key="'bundle-' + index" style="page-break-inside: avoid;">
                          <td class="border-0 size18">
                            <strong>({{ entry.bundle.name }})</strong>
                          </td>

                          <td class="border-0 size18 text-right" style="padding-left: 1.5rem">
                            {{ entry.bundleQty }} Pcs
                          </td>

                          <td class="border-0 size18 text-right">
                            {{ entry.bundle.price | formatInvoice }}
                          </td>

                          <td class="border-0 size18 text-right">
                            -
                          </td>

                          <td class="border-0 size18 text-right">
                            {{ entry.bundle.price | formatInvoice }}
                          </td>

                          <td class="border-0 size18 text-right">
                            {{ entry.bundleTotal | formatInvoice }}
                          </td>
                        </tr>

                        <!-- Bundle Detail -->
                         <tr v-if="entry.bundle.show_detail_on_invoice !== false" v-for="(bundleItem, bi) in entry.items"
                           :key="'bundle-item-' + index + '-' + bi" style="page-break-inside: avoid;">
                          <td class="border-0 size18 pl-4">
                            • {{ bundleItem.name }}
                          </td>

                          <td class="border-0 size18 text-right" style="padding-left: 1.5rem">
                            {{ bundleItem.qty.toString().replace(".", ",") }}
                            {{ bundleItem.unit }}
                          </td>

                          <td colspan="4" class="border-0"></td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
                <hr class="my-1" style="border-top: 1px solid #000" />
                <b-row>
                  <b-col cols="6">
                    <b-row>
                      <b-col cols="6">
                        <h6 class="size18 text-black">TTD Penerima</h6>
                      </b-col>
                      <b-col cols="6">
                        <h6 class="size18 text-black pl-2 text-center">
                          Hormat Kami
                        </h6>
                      </b-col>
                    </b-row>
                    <b-col lg="12" style="margin-top: 60px">
                      <h6 class="size18 text-black mb-0">Note:</h6>
                      <h6 class="size18 text-black mb-0 font-italic" v-if="result.display_vat">
                        *Harga barang sudah termasuk PPn 11%
                      </h6>
                     <h6 class="size18 text-black mb-0 font-italic" style="white-space: pre-line;">
                        {{ result.invoice_notes }}
                      </h6>
                      <h6 v-if="result.returs_id && result.returs_id.length > 0" class="text-black mt-4">
                        {{ result.returs_id.join(", ") }}
                      </h6>
                      <h6 v-if="result.deleted_by" class="size10 fw-bold-700 text-danger">
                        Dibatalkan oleh : {{ result.deleted_by.name }} /
                        {{ result.deleted_at }}
                      </h6>
                    </b-col>
                  </b-col>
                  <b-col cols="6">
                    <div class="d-flex justify-content-between">
                      <h6 class="size18 text-black mb-0 fw-bold-700">
                        Sub Total
                      </h6>
                      <h6 class="size18 text-black mb-0 fw-bold-700">
                        {{ result.subtotal | formatAmount }}
                      </h6>
                    </div>
                    <div v-if="result.discount_value > 0" class="d-flex justify-content-between">
                      <h6 class="size18 text-black mb-0">Diskon Tambahan</h6>
                      <h6 v-if="result.discount_type == 'fixed'" class="size18 text-black mb-0">
                        - {{ result.discount_value | formatAmount }}
                      </h6>
                      <h6 v-if="result.discount_type == 'percent'" class="size18 text-black mb-0">
                        - {{ result.discount_value }}%
                      </h6>
                    </div>
                    <div v-if="result.additional_fee_total > 0" class="d-flex justify-content-between">
                      <h6 class="size18 text-black mb-0 fw-bold-700">
                        Total Biaya Tambahan
                      </h6>
                      <h6 class="size18 text-black mb-0 fw-bold-700">
                        {{ result.additional_fee_total | formatAmount }}
                      </h6>
                    </div>
                    <info-additional-cost :result="result" />
                    <!-- Split Payment -->
                    <hr v-if="result.payments && result.payments.length > 1" class="mb-25"
                      style="border-top: 1px solid #000" />
                    <h6 class="size18 text-black size18 fw-bold-700 mb-0"
                      v-if="result.payments && result.payments.length > 1">
                      Pembayaran Terbagi
                    </h6>
                    <div class="d-flex justify-content-between" v-for="(payment, indexPayment) in result.payments"
                      :key="indexPayment">
                      <h6 class="size18 text-black size18 mb-0 text-capitalize mb-0">
                        {{ paymentMethods(payment.payment_method) }}
                        {{
                          payment.payment_method == "transfer"
                            ? " ke " + payment.bank_account_payment.bank.name
                            : ""
                        }}
                      </h6>
                      <h6 class="size18 text-black size18 mb-0" v-if="payment.payment_method === 'point'">
                        {{ parseFloat(payment.amount) | formatPoint }}
                      </h6>
                      <h6 class="size18 text-black size18 mb-0" v-else>
                        {{ parseFloat(payment.amount) | formatAmount }}
                      </h6>
                    </div>
                    <hr v-if="result.payments && result.payments.length > 1" class="mt-0 mb-25"
                      style="border-top: 1px solid #000" />
                    <!-- Total Split Payment -->
                    <div v-if="result.payments && result.payments.length > 1" class="d-flex justify-content-between"
                      style="margin-bottom: 0.5rem">
                      <h6 class="size18 text-black size18 mb-0">
                        Total Pembayaran
                      </h6>
                      <h6 class="size18 text-black mb-0">
                        {{
                          sumSplitPayment(result.payments) | formatAmountInvoice
                        }}
                      </h6>
                    </div>
                    <div v-if="result.discount_total > 0" class="d-flex justify-content-between">
                      <h6 class="text-black size18 mb-0 fw-bold-700">
                        Total Diskon
                      </h6>
                      <h6 class="text-black size18 mb-0 fw-bold-700">
                        {{ result.discount_total | formatAmount }}
                      </h6>
                    </div>
                    <div class="d-flex justify-content-between">
                      <h6 class="text-black size18 mb-0 fw-bold-700">
                        Grand Total
                      </h6>
                      <h6 class="text-black size18 mb-0 fw-bold-700">
                        {{ result.total | formatAmount }}
                      </h6>
                    </div>
                    <div class="d-flex justify-content-between" v-if="isUsedCustomerPoint">
                      <h6 class="text-black size18 mb-0 fw-bold-700">
                        Point yang didapat
                      </h6>
                      <h6 class="text-black size18 mb-0 fw-bold-700">
                        {{ totalLoyaltyPoint | formatPoint }}
                      </h6>
                    </div>
                    <!-- <div
                      class="d-flex justify-content-between"
                    >
                      <h6 class="text-black mb-0">
                        {{ paymentMethods(result.payment_method) }}
                      </h6>
                      <h6 class="text-black mb-0">
                        {{ result.cash_total_payment | formatAmount }}
                      </h6>
                    </div> -->
                    <div v-if="
                      result &&
                      result.payment_method !== 'piutang' &&
                      result.piutang &&
                      result.piutang.amount > 0
                    " class="d-flex justify-content-between">
                      <h6 class="text-black size18 mb-0 text-capitalize">
                        Piutang
                      </h6>
                      <h6 class="text-black size18 mb-0">
                        {{
                          result.piutang && result.piutang.amount | formatAmount
                        }}
                      </h6>
                    </div>
                    <div v-if="result.payment_method !== 'piutang'" class="d-flex justify-content-between">
                      <h6 class="text-black size18 mb-0" v-if="result.payment_method === 'wallet'">
                        Sisa Deposit
                      </h6>
                      <h6 class="text-black size18 mb-0" v-if="result.payment_method === 'wallet'">
                        {{
                          result.payment_customer &&
                          result.payment_customer.wallet_balance
                          | formatAmountInvoice
                        }}
                      </h6>
                      <div class="d-flex justify-content-between w-100 mb-25" v-if="
                        (result.payment_method !== 'wallet' &&
                          result.payments &&
                          !result.payments.length > 1) ||
                        (result.returs_id && result.returs_id.length)
                      ">
                        <h6 class="text-black size18 mb-0">Kembali</h6>
                        <h6 class="text-black size18 mb-0">
                          {{ result.cash_change | formatAmountInvoice }}
                        </h6>
                      </div>
                    </div>
                    <div v-if="result.discount_total > 0" class="d-flex justify-content-between">
                      <h6 class="text-black size18 mb-0">Anda Hemat</h6>
                      <h6 class="text-black size18 mb-0">
                        {{ result.discount_total | formatAmount }}
                      </h6>
                    </div>
                  </b-col>
                </b-row>
                <!-- <b-row class="mt-3">
                  <b-col cols="6">
                    <h6 class="text-black">TTD Penerima</h6>
                  </b-col>
                  <b-col cols="6">
                    <h6 class="text-black pl-2 text-center">
                      Hormat Kami
                    </h6>
                  </b-col>
                </b-row> -->
              </b-col>

              <!-- <b-col lg="12" class="pl-0 mb-0">
                <b-row>
                  <b-col lg="12" style="margin-top: 113px">
                    <h6 class="text-black mb-0">Note:</h6>
                    <h6
                      class="text-black mb-0 font-italic"
                      v-if="result.display_vat"
                    >
                      *Harga barang sudah termasuk PPn 11%
                    </h6>
                    <h6 class="text-black mb-0 font-italic">
                      {{ result.invoice_notes }}
                    </h6>
                    <h6
                      v-if="result.returs_id && result.returs_id.length > 0"
                      class= text-black mt-4 mb-0"
                    >
                      {{ result.returs_id.join(", ") }}
                    </h6>
                  </b-col>
                </b-row>
              </b-col> -->
            </b-row>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BContainer, BRow, BCol, BImg } from "bootstrap-vue";
import moment from "moment";
import InfoAdditionalCost from "./InfoAdditionalCost.vue";
const { hostname, protocol, port } = window.location;
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BContainer,
    InfoAdditionalCost,
  },
  props: {
    /* eslint-disable vue/require-default-prop */
    result: {
      type: Object,
    },
    merchant: {
      type: Object,
    },
    deliveryNumbers: {
      type: Array,
    },
  },
  data() {
    return {
      moment,
      imageLogo: null,
      isUsedCustomerPoint: false,
      totalLoyaltyPoint: 0
    };
  },
  computed: {
     groupedItems() {
    const items = this.result?.items || [];
    const result = [];
    const seenBundles = {};

    for (const item of items) {
      // Regular product
      if (!item.bundle) {
        result.push({
          type: "product",
          item,
        });
        continue;
      }

      const bundleUuid = item.bundle.uuid;

      if (seenBundles[bundleUuid]) continue;

      seenBundles[bundleUuid] = true;

      const bundleItems = items.filter(
        i => i.bundle && i.bundle.uuid === bundleUuid
      );

      const bundleQty = Number(item.bundle.bundle_qty || 0);
      // item.bundle.price is backed by bundle_price_snapshot on the backend for new orders
      // (or reverse-calculated from item totals for legacy orders).
      // Either way the backend guarantees the historically correct value.
      const bundlePrice = Number(item.bundle.price || 0);
      const bundleTotal = bundlePrice * bundleQty;

      result.push({
        type: "bundle",
        bundle: item.bundle,
        items: bundleItems,
        bundleQty,
        bundleTotal,
      });
    }

    return result;
  },

  paginatedItems() {
    const items = this.groupedItems;

    // Prevent page break when a bundle contains many detail rows
    const hasLongBundle = items.some(entry =>
      entry.type === "bundle" &&
      entry.bundle.show_detail_on_invoice !== false &&
      entry.items.length > 3
    );

    if (hasLongBundle) return [items];

    const pages = [];
    for (let i = 0; i < items.length; i += 10) {
      pages.push(items.slice(i, i + 10));
    }

    return pages;
  },
    totalPoint() {
      return this.result?.previous_point_balance || 0
    },
    totalRetur() {
      return this.result?.returs?.reduce((total, item) => total + item.return_value, 0);
    },
    totalDiscountRetur() {
      return this.result?.returs?.reduce((total, item) => total + item.discount, 0);
    },
    // paginatedItems() {
    //   const items = this.result.items || [];

    //   // If some item name is long, skip pagination
    //   if (items.some(i => i.name?.length > 30)) return [items];

    //   // Paginate items by 10 per page
    //   const pages = [];
    //   for (let i = 0; i < items.length; i += 10) {
    //     pages.push(items.slice(i, i + 10));
    //   }

    //   return pages;
    // },
    formattedCreatedAt() {
      const date = this.result?.created_at || this.result?.date;
      if (!date) return '';
      return this.moment(date).format('DD/MMM/YYYY HH:mm:ss');
    }
  },
  watch: {
    result: {
      handler(value) {
        if (value) {
          const isValid = this.hasNoImageExtension(value?.branch?.photo_url)
          this.imageLogo = isValid ? value.branch?.photo_url : `${protocol}//${hostname}${port !== "" ? `:${port}` : ""}/toqoo-green.svg`
          this.isUsedCustomerPoint = value?.branch?.loyalty_rules?.is_used
          this.totalLoyaltyPoint = value?.loyalty_point
        }
      },
      deep: true
    }
  },
  mounted() {
    const isValid = this.hasNoImageExtension(this.result?.branch?.photo_url)
    this.imageLogo = isValid ? this.result?.branch?.photo_url : ''
    this.isUsedCustomerPoint = this.result?.branch?.loyalty_rules?.is_used
    this.totalLoyaltyPoint = this.result?.loyalty_point
  },
  methods: {
    hasNoImageExtension(url) {
      const validExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
      return validExtensions.test(url);
    },
    sumSplitPayment(payments) {
      let total = 0;
      for (let index = 0; index < payments.length; index++) {
        const element = payments[index];
        total += parseFloat(element.amount);
      }
      return total;
    },
    paymentMethods(method) {
      const paymentMapping = {
        cash: "Tunai",
        card: "Debit/Kredit",
        transfer: "Transfer",
        giro: "Giro",
        wallet: "Deposit",
        piutang: "Piutang",
        point: "Customer Point",
      };

      return paymentMapping[method] || "-";
    },
    sanitizeHTML(html) {
      return html?.replace(/<\/?p>/g, "");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";

.table thead tr th {
  font-weight: 800;
  color: #2b324f;
  font-size: 16px;
}

.table tbody tr td {
  font-weight: 500;
  color: #2b324f;
  font-size: 16px;
}

.bg-wave {
  background-image: url("../assets/images/wave-bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
}

button {
  &.bg-white {
    background-color: #ffffff !important;
    border: 1px solid $light--3 !important;
    color: $dark !important;
  }
}

label {
  font-size: 14px;
  color: $dark;
  font-weight: 600;
}

.vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
}

.custom__input {
  height: 52px;
  background: #eff1f5;
  border: 1px solid #e4e5ec;
  border-radius: 8px;
}

.vs__dropdown-toggle {
  height: 52px;
  background-color: #eff1f5;
  border: 1px solid #e4e5ec;
  border-radius: 8px;
}
</style>
